export default "__VITE_PUBLIC_ASSET__4ff69641__"